import { render, staticRenderFns } from "./ChannelManagementMethodView.vue?vue&type=template&id=29ae706e&"
import script from "./ChannelManagementMethodView.vue?vue&type=script&lang=js&"
export * from "./ChannelManagementMethodView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports